export const frontmatter = {
    "draft": false,
    "title": "Teams",
    "description": "Team management from the system administration.",
    "sidebar_label": "Teams",
    "sidebar_group": "reference",
    "sidebar_order": 3
}

export const toc = []